$(document).ready(function () {
    var help_divs = $('.help-div');
    var help_links = $('.help-link');
    var help_nav_div = $('#help-nav-div');
    var help_content_div = $('#help-content-div');
    var help_content_margin_div = $('#help-content-margin-div');

    var selected_link = $('a[href="' + location.hash + '"]');
    var selected_help_div = $(location.hash);
    if (!selected_help_div.length) {
        selected_help_div = $(help_divs[0]);
    }

    function hide_all_help_divs() {
        help_divs.each(function (index, help_div) {
            $(help_div).addClass('hide');
        });
    }

    function resize_help_container() {
        var nav_height = help_nav_div.outerHeight(true);
        var content_height = selected_help_div.outerHeight(true);
        var margin_div_padding_and_margin = help_content_margin_div.outerHeight(true) - help_content_margin_div.height();
        var new_height = 0;
        var min_height = $(window).height(); //min_height = window height is required because if the minimum height is too small, the screen bounces too much during navigation
        if (min_height > content_height) {
            new_height = min_height;
        } else {
            new_height = content_height;
        }
        help_nav_div.height(new_height + margin_div_padding_and_margin);
        help_content_div.height(new_height + margin_div_padding_and_margin);
    }

    function reveal_help_div(ele) {
        hide_all_help_divs();
        selected_help_div = ele;
        ele.removeClass('hide');
        resize_help_container();
    }

    function remove_active_from_all_help_links() {
        help_links.each(function (index, help_link) {
            $(help_link).removeClass('active');
        });
    }

    function update_nav_styling(ele) {
        remove_active_from_all_help_links();
        ele.addClass('active');
    }

    help_links.on("click", function (event) {
        event.stopPropagation();
        event.preventDefault();
        var clicked_ele = $(event.currentTarget);
        var target_ele_selector = event.target.getAttribute('href');
        var target_ele = $(target_ele_selector);
        update_nav_styling(clicked_ele);
        reveal_help_div(target_ele);
        history.replaceState(null, '', target_ele_selector); // Updates the url with new hash
        $('html, body').animate({"scrollTop": $('#help-content-div').offset().top});

    });

    //Init
    reveal_help_div(selected_help_div);
    update_nav_styling(selected_link);
});